import React, { useState } from "react";
import { Row, Col, Button, Select, Radio, Space, Steps } from "antd";
import { ArrowLeftOutlined } from "@ant-design/icons";
import { Link } from "react-router-dom";
import "./Application2.css";
import "../components/StepsTracker.css";

const { Option } = Select;

const Application2: React.FC = () => {
  const [householdIncome, setHouseholdIncome] = useState<string>("");
  const [age, setAge] = useState<string>("");

  const handleIncomeChange = (value: string) => {
    setHouseholdIncome(value);
  };

  const handleAgeChange = (e: any) => {
    setAge(e.target.value);
  };

  return (
    <div className="application-step-container">
      <div className="application-title-card">
        <div className="title-card-content">
          <div className="city-name-title">City of New Orleans, Louisiana</div>
          <h1 className="program-title-main">E-Bike Incentive Application</h1>
        </div>
      </div>

      <div className="progress-tracker-container">
        <Steps
          current={1}
          className="progress-tracker-steps"
          items={[
            { title: "Review Eligibility" },
            { title: "Confirm Details" },
            { title: "Personal Information" },
            { title: "Upload Documents" },
            { title: "Income Verification" },
            { title: "Survey" },
            { title: "Future Communications" },
            { title: "Terms & Conditions" },
          ]}
        />
      </div>

      <div className="main-step-card">
        <div className="step-header-container">
          <div className="step-badge">
            <div className="step-label">STEP</div>
            <div className="step-number">2</div>
          </div>
          <h2 className="step-title-main">Confirm age & household income</h2>
        </div>

        <div className="step-divider" />

        <div className="form-section">
          <Row gutter={[0, 40]}>
            <Col span={24}>
              <div className="form-group">
                <label className="form-label">Annual Household Income</label>
                <Select
                  placeholder="$"
                  className="income-dropdown"
                  size="large"
                  value={householdIncome}
                  onChange={handleIncomeChange}
                >
                  <Option value="under-25000">Under $25,000</Option>
                  <Option value="25000-49999">$25,000 - $49,999</Option>
                  <Option value="50000-74999">$50,000 - $74,999</Option>
                  <Option value="75000-99999">$75,000 - $99,999</Option>
                  <Option value="100000-124999">$100,000 - $124,999</Option>
                  <Option value="125000-149999">$125,000 - $149,999</Option>
                </Select>
              </div>
            </Col>

            <Col span={24}>
              <div className="form-group">
                <label className="form-label">My Age Is</label>
                <Radio.Group
                  value={age}
                  onChange={handleAgeChange}
                  className="age-radio-group"
                >
                  <Space direction="vertical" size={12}>
                    <Radio value="17-or-younger" className="age-radio-option">
                      17 years or younger
                    </Radio>
                    <Radio value="18-or-older" className="age-radio-option">
                      18 years or older
                    </Radio>
                  </Space>
                </Radio.Group>
              </div>
            </Col>
          </Row>
        </div>
      </div>

      <div className="navigation-buttons">
        <Link to="/application1">
          <Button
            type="default"
            icon={<ArrowLeftOutlined />}
            className="back-button"
          >
            Back
          </Button>
        </Link>
        <Link to="/application3">
          <Button type="primary" className="next-button" size="large">
            Next
          </Button>
        </Link>
      </div>
    </div>
  );
};

export default Application2;
